import { Box } from '@wix/design-system';
import { Check, Sparkles } from '@wix/wix-ui-icons-common';
import React from 'react';

type IconType = 'check' | 'ai';
type IconMode = 'default' | 'sale';

interface FeatureIconProps {
  iconName?: IconType;
  mode?: IconMode;
  dataHook?: string;
}

const modeStyles: Record<
  IconMode,
  { backgroundColor: string; iconColor: string }
> = {
  default: {
    backgroundColor: '#e0d3ff',
    iconColor: '#4202a8',
  },
  sale: {
    backgroundColor: 'white',
    iconColor: '#ff784b',
  },
};

export const FeatureIcon: React.FC<FeatureIconProps> = ({
  iconName = 'check',
  mode = 'default',
  dataHook,
}) => {
  const { backgroundColor, iconColor } = modeStyles[mode];
  const IconComponent = iconName === 'ai' ? Sparkles : Check;

  return (
    <Box
      dataHook={dataHook}
      width='18px'
      height='18px'
      align='center'
      verticalAlign='middle'
      borderRadius='50%'
      backgroundColor={backgroundColor}
    >
      <IconComponent style={{ color: iconColor }} />
    </Box>
  );
};
